import React from 'react';
import './PromptBuilder.css';

const PromptBuilder = ({ 
  persona, 
  setPersona, 
  metaPrompt, 
  setMetaPrompt, 
  selectedKeywords, 
  setSelectedKeywords,
  onClearKeywords,
  bookTitle,
  includeBookTitle,
  setIncludeBookTitle 
}) => {
  const buildFullPrompt = () => {
    const parts = [];
    if (includeBookTitle && bookTitle?.trim()) {
      parts.push(`As discussed in "${bookTitle.trim()}",`);
    }
    if (persona.trim()) parts.push(`As a ${persona.trim()},`);
    if (metaPrompt.trim()) parts.push(metaPrompt.trim());
    if (selectedKeywords.trim()) parts.push(`Focus on: ${selectedKeywords.trim()}`);
    return parts.join(' ');
  };

  const handleSendToLLM = (llm) => {
    const fullPrompt = buildFullPrompt();
    if (!fullPrompt) {
      alert('Please add some content to the prompt builder first.');
      return;
    }
    const encodedPrompt = encodeURIComponent(fullPrompt);
    let url = '';
    if (llm === 'chatgpt') {
      url = `https://chat.openai.com/?q=${encodedPrompt}`;
    } else if (llm === 'grok') {
      url = `https://grok.com/?q=${encodedPrompt}`;
    }
    window.open(url, '_blank');
  };

  return (
    <div className="prompt-builder">
      <h4 className="prompt-builder-title">🛠️ Prompt Builder</h4>
      
      <div className="prompt-field">
        <label>Persona:</label>
        <input
          type="text"
          value={persona}
          onChange={(e) => setPersona(e.target.value)}
          placeholder="e.g., CIO looking to improve processes"
          className="prompt-input"
        />
      </div>

      <div className="prompt-field">
        <label>Context:</label>
        <textarea
          value={metaPrompt}
          onChange={(e) => setMetaPrompt(e.target.value)}
          placeholder="Book context and themes..."
          className="prompt-textarea"
          rows={3}
        />
      </div>

      <div className="prompt-field">
        <label>
          Keywords:
          {selectedKeywords && (
            <button 
              className="clear-keywords-btn"
              onClick={onClearKeywords}
              title="Clear keywords"
            >
              ✕
            </button>
          )}
        </label>
        <textarea
          value={selectedKeywords}
          onChange={(e) => setSelectedKeywords(e.target.value)}
          placeholder="Click keywords above to add them here..."
          className="prompt-textarea"
          rows={2}
        />
      </div>

      <div className="prompt-checkbox">
        <label>
          <input
            type="checkbox"
            checked={includeBookTitle}
            onChange={(e) => setIncludeBookTitle(e.target.checked)}
          />
          Include book title in prompt
        </label>
      </div>

      <div className="prompt-actions">
        <button 
          className="llm-send-btn chatgpt-btn"
          onClick={() => handleSendToLLM('chatgpt')}
          title="Send to ChatGPT"
        >
          <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg" alt="ChatGPT" className="btn-icon" />
          ChatGPT
        </button>
        <button 
          className="llm-send-btn grok-btn"
          onClick={() => handleSendToLLM('grok')}
          title="Send to Grok"
        >
          <span className="btn-icon" style={{ fontSize: '16px', fontWeight: 'bold' }}>𝕏</span>
          Grok
        </button>
      </div>
    </div>
  );
};

export default PromptBuilder;
